

export const space = (factor = 1) => factor * 4;

export const colors = {

    primary: "#009D9C",
    primaryDark: "#2F4858",
    primaryLight: "#3ED696",

    onPrimary: "white",

    delete: "#a00",

    subtle: "#eaeaea",

    neutral100: "#171717",
    neutral90: "#262626",
    neutral80: "#404040",
    neutral70: "#525252",
    neutral60: "#737373",
    neutral50: "#a3a3a3",
    neutral40: "#d4d4d4",
    neutral30: "#e6e6e6",
    neutral20: "#f5f5f5",
    neutral10: "#fafafa",

}


const button = {
    "--button-color": colors.primary,
    "--on-button-color": colors.onPrimary,
    "--button-hover-color": colors.primaryDark,
    "--on-button-hover-color": "var(--on-button-color)",
    padding: space(2),
    background: "var(--button-color)",
    color: "var(--on-button-color)",
    textAlign: "center",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "133ms all ease-in-out",
    outline: "none",
    border: "none",
    "&:hover": {
        color: "var(--on-button-hover-color)",
        background: "var(--button-hover-color)",
    }
}

export const buttons = {
    primary: button,
    secondary: {
        ...button,
        "--button-color": colors.neutral20,
        "--button-hover-color": colors.neutral30,
        "--on-button-color": colors.primary,
        "--on-button-hover-color": colors.primaryDark,
        fontWeight: "normal",
    },
    text: {
        ...button,
        "--button-color": "transparent",
        "--button-hover-color": colors.neutral20,
        "--on-button-color": colors.primary,
        "--on-button-hover-color": colors.primaryDark,
    },
    outline: {
      ...button,
        "--button-color": "transparent",
        "--button-hover-color": colors.neutral20,
        "--on-button-color": colors.primary,
        "--on-button-hover-color": colors.primaryDark,
        border: "1px solid "+colors.primary,
        fontWeight: "normal",
    },
    error: {
        ...button,
        "--button-color": "#D32F2F",
        "--on-button-color": "white",
        "--button-hover-color": "#C62828",
        fontWeight: "normal",
    }
}

export const label = {
    fontSize: "0.8em",
    lineHeight: "1.4em",
    color: colors.neutral70,
};

export const input = {
    padding: space(2),
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: colors.neutral40,
    backgroundColor: "white",
    borderRadius: 2,
    appearance: "none",
    boxSizing: "border-box",
    margin: 0,

    "&:focus, &:focus-visible, &:active": {
        outlineColor: colors.primary,
        borderColor: colors.primary,
    }
}

export const select = {

    ...input,

    backgroundImage: 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc5MiIgaGVpZ2h0PSIxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xNDA4IDcwNHEwIDI2LTE5IDQ1bC00NDggNDQ4cS0xOSAxOS00NSAxOXQtNDUtMTlMNDAzIDc0OXEtMTktMTktMTktNDV0MTktNDUgNDUtMTloODk2cTI2IDAgNDUgMTl0MTkgNDV6Ii8+PC9zdmc+")',
    backgroundSize: "16px auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "100%",
    backgroundOrigin: "content-box",
    cursor: "pointer",
    minWidth: 80,
    width: "100%",

    "&:invalid": {
        color: "red",
    }
}